import withProps from 'recompose/withProps';
import hoistStatics from 'recompose/hoistStatics';

import { MOUNT_NODE } from '../constants';

// Render a SUIR modal or popup into a designated DIV using the `mountNode` property.
// This allows to render the markup for modal and popups into the React application root node hierarchy, thus
// allowing to scope CSS rules based on classes set on that element. In such a scenario, the application should
// render such a DIV
export const withMountNode = (component) =>
  hoistStatics(
    withProps(() => ({
      mountNode: document.getElementById(MOUNT_NODE) || document.body,
    })),
  )(component);

// This is necessary in order to provide modals with an outlet outside of the Naviance Student application root ("#root").
// It must be outside for accessibility purposes. Notably, to allow the main content of the application to have its
// aria-hidden property switched on/off independently of the modal content.
export function setupMountNode() {
  const matchContainerSelector = 'body > .microtemplate';

  /* istanbul ignore else */
  if (!document.querySelector(matchContainerSelector)) {
    const modalContainer = document.createElement('div');
    // Using this class allows the modal to inherit the appropriate styles despite being located outside of the main active-match DOM tree
    modalContainer.className = 'microtemplate';
    modalContainer.innerHTML = `<div id="${MOUNT_NODE}"></div>`;
    document.body.appendChild(modalContainer);
  }

  const cleanupMountNode = () => {
    const modalContainer = document.querySelector(matchContainerSelector);
    /* istanbul ignore else */
    if (modalContainer) {
      document.body.removeChild(modalContainer);
    }
  };

  return cleanupMountNode;
}
